import React from 'react';

import type { GradeScore } from '../../../../types/frapi-types.js';

import Grade from './Grade.js';

type GradesProps = {
  grades: {
    name: string;
    value: GradeScore;
  }[];
};

const Grades: React.FC<GradesProps> = ({ grades }) => {
  return (
    <div className="grades">
      <p className="title">Vurdering</p>
      <div className="sub-grades">
        {grades.map((grade, index) => {
          return grade.value ? (
            <Grade
              key={`grade-${index}`}
              name={grade.name}
              value={grade.value}
            />
          ) : (
            <></>
          );
        })}
      </div>
    </div>
  );
};

export default Grades;
